import React from 'react';
import classNames from 'classnames';

import { HeaderInitInterface, HeaderModeEnum } from './header.interface';
import styles from './header.module.scss';

import FacebookApps from '../facebook-apps/facebook-apps.component';
import ForbesLogoLink from '../forbes-logo-link/forbes-logo-link.component';

const Header: React.FunctionComponent<HeaderInitInterface> = ({
  mode = HeaderModeEnum.DEFAULT,
}) => {

  const modeClassName = ({
    [HeaderModeEnum.DEFAULT]: styles.isDefult,
    [HeaderModeEnum.FIXED]: styles.isFixed,
    [HeaderModeEnum.HIDDEN]: styles.isHidden,
  } as Record<HeaderModeEnum, string>)[mode];

  return (
    <header
      className={classNames(
        styles.component,
        modeClassName,
      )}
    >
      <FacebookApps />

      <ForbesLogoLink />
    </header>
  );
};

export default Header;
